import {AUTH_CASES} from '../constants';
import type {AuthCase, LocalAuth} from '../types';

export const getAuthCase = ({
  localAuth,
  localExpiry,
}: {
  localAuth: LocalAuth | null;
  localExpiry: number | null;
}): AuthCase => {
  if (localAuth) {
    const isExpired = localExpiry && Date.now() > localExpiry;
    if (isExpired) return AUTH_CASES.EXPIRED;
    return AUTH_CASES.VALID;
  }
  return AUTH_CASES.NONE;
};
